/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import CustomInput from 'components/input/CustomInput';
import AvatarUpload from 'components/input/AvatarUpload';
import { uploadAvatar } from 'services/auth.service';
import { isSuccessCode } from 'utils/common';
import { useSelector } from 'react-redux';
import { commonSelector, getAccountDetailAction } from 'store/common';
import { dispatch } from 'store/Store';

type FormDataType = {
  phoneNumber?: string;
  email?: string;
};

function EditProfileContainer() {
  const { t } = useTranslation();
  const { language, accountDetail } = useSelector(commonSelector);

  const [formData, setFormData] = useState<FormDataType>({
    phoneNumber: accountDetail?.phoneNumber,
    email: accountDetail?.email,
  });

  const handleUpdateLoadAvatar = async (base64: string) => {
    const response = await uploadAvatar({
      base64,
    });
    const { code } = response.data;
    if (isSuccessCode(code)) {
      dispatch(getAccountDetailAction());

      return true;
    } else return false;
  };

  return (
    <div className={styles.wrapper}>
      <AvatarUpload onUpload={handleUpdateLoadAvatar} />
      <div className={styles.form}>
        <CustomInput
          title={t('title.phone-number')}
          placeholder={t('placeholder.type-phone-number')}
          value={accountDetail?.phoneNumber}
          required
          disabled
        />
        <CustomInput
          title={t('title.email')}
          placeholder={t('placeholder.type-email')}
          value={accountDetail?.email}
          disabled
        />
      </div>
      {/* <TextButton
        title={t('button.save-change')}
        variant="solid"
        color="warning"
        style={{
          marginTop: '24px',
        }}
        disabled
      /> */}
    </div>
  );
}

export default EditProfileContainer;
